import React from "react";
import { Loader, LoaderSize } from "components/common/Loader.component";


export const ImageLoading = (): React.ReactElement => {
    return (
        <div className={"page_container"}>
            <div className="attachment-image-container__loading-spinner position-absolute">
                        <Loader size={LoaderSize.Medium} role="status" ariaHidden={false}/>
            </div>
        </div>
    )
}

export default ImageLoading;